import { useEffect, useState } from "react";
import "./LoadingSpinner.css";

interface Props {
  loading: boolean;
  text?: string;
  isFullscreen?: boolean;
}

function LoadingSpinner({ loading, text = "Bitte warten", isFullscreen = false }: Props) {
  const [visible, setVisible] = useState(loading);

  useEffect(() => {
    if (loading) {
      setVisible(true);
    } else {
      const timeout = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [loading]);

  return (
    <div
      className={`overlay ${isFullscreen ? "fullscreen" : "contained"} ${loading ? "fade-in" : "fade-out"}`}
      style={{ display: visible ? "flex" : "none" }}
    >
      <div className="spinner-container">
        <div className="spinner">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="loading-text">
          {text}
          <span className="dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
